export const collapseContextKey = Symbol('collapseContextKey')